export const Roles = Object.freeze({
    Admin: "Admin",
    Client: "Client",
    Player: "Player"
});